enum TableColumns {
  DisplayName = 'displayName',
  GatewayMonitorings = 'gatewayMonitorings',
  SystemMonitorings = 'systemMonitorings',
  DevicesMonitorings = 'devicesMonitorings',
  Note = 'note',
}

export default TableColumns;
